<div class="map-wrapper" id="wraper_map">
  <div class="d-flex flex-column h-100">
    <div class="map-border">
      <app-sidebar></app-sidebar>

      <div class="d-flex h-100 w-100">
        <app-panel-monitoreo></app-panel-monitoreo>
        <app-map-aside position="left"></app-map-aside>
        <div style="flex: 1; position: relative">
          <ng-container
            *ngIf="
              !(isDestroyedHistoryMap$ | async) && (isHiddenHistoryMap$ | async)
            "
          >
            <button
              pTooltip="Abrir historial"
              tooltipPosition="left"
              showDelay="300"
              (click)="showHistoryMap()"
              class="custom-button"
            >
              <svg width="24" height="24" fill="currentColor">
                <use xlink:href="./assets/icons/sprite.svg#view-sidebar"></use>
              </svg>
            </button>
          </ng-container>
          <app-map-view></app-map-view>
        </div>
        <ng-container *ngIf="!(isDestroyedHistoryMap$ | async)">
          <app-vehicle-history-drawer
            [isHidden]="isHiddenHistoryMap$ | async"
            [dataHistoryDrawer]="dataHistoryDrawer$ | async"
            (hiddenHistoryDrawer)="hiddenHistoryMap()"
            (destroyedHistoryDrawer)="destroyedHistoryMap()"
            (mapResize)="mapResize()"
          ></app-vehicle-history-drawer>
        </ng-container>
      </div>
      <!-- <app-panel-historial-grafico></app-panel-historial-grafico> -->
      <div class="popup-container" id="popupContainer"></div>
    </div>
  </div>
</div>
